import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseCellRendererComponent } from '@y42/ag-grid';
import { connectState } from '@y42/angular/util';
import { TestResultStatus } from '@y42/data-test';
import { map } from 'rxjs/operators';

export interface DataTestLatestJobStatus {
  value: TestResultStatus | null;
  errors: string[];
}

@UntilDestroy()
@Component({
  selector: 'y42-data-test-latest-job-status-cell-renderer',
  templateUrl: './data-test-latest-job-status-cell-renderer.component.html',
  styleUrls: ['./data-test-latest-job-status-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTestLatestJobStatusCellRendererComponent extends BaseCellRendererComponent<DataTestLatestJobStatus> {
  readonly state = connectState(this, {
    status: this.valueAsSingle$.pipe(map((param) => param?.value ?? null)),
    errorMessages: this.valueAsSingle$.pipe(map((param) => param?.errors)),
  });
}
